<template>
    <div class="faq-questions">
        <PCFaq :data="data"
               class="pc" />
        <PadFaq :data="data"
                class="pad" />
        <MobileFaq :data="data"
                   class="mobile" />
    </div>
</template>

<script>
import PCFaq from './PCFaq.vue';
import PadFaq from './PadFaq.vue';
import MobileFaq from './MobileFaq.vue';

export default {
    name: 'Questions',
    components: {
        PCFaq,
        PadFaq,
        MobileFaq
    },
    data() {
        return {
        };
    },
    computed: {
        faq() {
            return this.$store.state.faqData;
        }
    },
    created() {
        if (!this.$route.params.index || !this.$route.params.index >= 4) {
            this.$router.push({ name: 'NotFound' });
        } else {
            const index = Number(this.$route.params.index);
            this.data = this.faq[index - 1].children;
        }
    },
};
</script>

<style lang="scss">
ol {
    padding-left: 1.5rem;
}
.category {
    color: #333;
}
.pt-40 {
    padding-top: 40px;
}
.faq-pc {
    padding: 40px 0;
    max-width: 1146px;
    font-size: 18px;
}
.faq-pad {
    padding: 20px 0;
    font-size: 18px;
}
.faq-mobile {
    padding: 20px 0;
    font-size: 18px;
}
.box {
    margin-bottom: 30px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.answer {
    background-color: #59c0d0;
    border-radius: 6px;
    color: #fff;
    padding: 20px;
}
.square {
    cursor: pointer;
    border-radius: 6px;
    height: 80px;
    background-color: #ecf6fc;
    font-size: 18px;
    color: #666;
    padding: 10px;
    padding-left: 20px;
    &:not(:last-child) {
        margin-right: 2%;
    }
    .square-title {
        flex: 1;
    }
    .square-icon {
        font-size: 30px;
    }
    &.opened {
        background-color: #59c0d0;
        color: #fff;
    }
}

.pc {
    display: none;
    @media (min-width: 768px) {
        display: block;
    }
    .square {
        width: 32%;
    }
}
.pad {
    display: none;
    @media screen and (min-width: 577px) and (max-width: 767px) {
        display: block;
    }
    .square {
        width: 49%;
    }
}
.mobile {
    display: none;
    @media (max-width: 576px) {
        display: block;
    }
    .square {
        width: 100%;
    }
}
</style>
